import axios from "axios";

// Эндпоинт аттестаций отдаёт чистые {count, results} без конверта
// {success, code, result}, принятого в остальном внутреннем API: тот конверт
// считает пустой список ошибкой (success: false), а пустой раздел — это
// нормальное состояние, а не сбой.
const getAttestations = async (context) => {
  await context.commit("setAttestations", null);
  try {
    const response = (
      await axios.get(
        `${process.env.VUE_APP_API_URL}/api/attestation/v1/attestations/?lang=${context.getters.attestationLang}`,
        {
          headers: {
            Authorization: localStorage.getItem("access")
              ? `Bearer ${localStorage.getItem("access")}`
              : "",
          },
        },
      )
    ).data;
    await context.commit("setAttestations", response);
  } catch (e) {
    await context.commit("setAttestations", { count: 0, results: [] });
    await context.commit("setError", "attestations");
  }
};

export default {
  getAttestations,
};
